<template>
  <div class="row m-0">
    <Loader
      v-if="showLoader"
    />
    <ResearchNavigation
      :research-name="research.campaign_name"
    />
    <Container>
      <Stepper
        v-model="step"
        :steps="steps"
        :show-prev-button="true"
        class="position-absolute w-100 top-0 left-0"
        style="posi"
      />
      <div class="mt-5 pt-2">
        <div
          class="d-flex justify-content-between
            flex-wrap flex-md-nowrap align-items-center mb-3 px-1"
        >
          <h6 class="text-muted m-0">
            <i>{{ activeStep.description }}</i>
          </h6>
          <div style="opacity: 0.2">
            Category:
            <select
              v-if="categories.length > 0"
              v-model="selectedCategory"
            >
              <option
                v-for="category in categories"
                :key="category.name"

                :value="category._id"
              >
                {{ category.name }}
              </option>
            </select>
          </div>
        </div>

        <component
          :is="activeStepComponentName"

          :key="activeStep.name"
          v-model="activeStep.model"
          :data="activeStep.data"
          :limit="activeStep.limit"
          item-text="name"
          node-text="name"

          @completed="activeStep.completed = $event"
        />
      </div>
    </Container>
    <Sidebar id="selection-sidebar">
      <div class="px-4">
        <div class="my-4 py-3">
          <h5 class="py-2">
            {{ activeStep.name }}
          </h5>
          <p>
            <small>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
              tempor incididunt ut labore et dolore magna aliqua.
            </small>
          </p>
        </div>
        <div
          v-if="isSortableListVisible"
        >
          <h5 class="py-2">
            YOUR SELECTION
          </h5>
          <SortableList
            v-model="activeStep.model"

            lock-axis="y"
            class="mb-4"
          >
            <SortableItem
              v-for="(model, index) in activeStep.model"
              :key="index"
              :item="model.name"
              :index="index"
              class="mb-3"
            />
          </SortableList>
        </div>
        <div v-else>
          <span class="text-uppercase">
            SELECT
            <b>{{ activeStep.name }}s</b>
          </span>
        </div>
      </div>
      <div class="px-3 mb-4 pb-3">
        <button
          v-if="isSortableListVisible"

          class="w-100 create-project-button deepify-bg-success border-0 text-center"
          @click="
            allStepsCompleted && (step === steps.length - 1) ?
              doResearch() :
              step += 1; window.scrollTo(0, 0)
          "
        >
          {{
            allStepsCompleted && (step === steps.length - 1) ?
              'DO RESEARCH' :
              'CONFIRM SELECTION'
          }}
        </button>
      </div>
    </Sidebar>
  </div>
</template>
<script>
import ResearchNavigation from '@/components/sidebars/ResearchNavigation.vue';
import Container from '@/components/core/Container.vue';
import Sidebar from '@/components/core/Sidebar.vue';
import SelectionGridList from '@/components/SelectionGridList.vue';
import SelectionTreeList from '@/components/SelectionTreeList.vue';
import SortableList from '@/components/SortableList.vue';
import SortableItem from '@/components/SortableItem.vue';
import Stepper from '@/components/Stepper.vue';

import API from '@/services/';
import {
  API_CATEGORY, API_POTENTIAL, API_OFFER, API_HOOK, API_MOTIVATION, API_ENDGAME, API_RESEARCH,
} from '@/helpers/config';

export default {
  components: {
    ResearchNavigation,
    Container,
    Sidebar,
    SelectionTreeList,
    SelectionGridList,
    SortableList,
    SortableItem,
    Stepper,
  },
  data() {
    return {
      window,
      showLoader: true,
      categories: [],
      selectedCategory: '5d397f5ad2dba0097400635e',
      step: 0,
      steps: [
        {
          name: 'TEKLİF',
          type: 'TREE',
          completed: false,
          description: 'Choose up to 1',
          model: [],
          data: [],
          limit: 1,
        },
        {
          name: 'HEDEF',
          type: 'GRID',
          completed: false,
          description: 'Choose up to 1',
          model: [],
          data: [],
          limit: 1,
        },
        {
          name: 'KANCA',
          type: 'GRID',
          completed: false,
          description: 'Choose up to 2',
          model: [],
          data: [],
          limit: 2,
        },
        {
          name: 'MOTİVASYON',
          type: 'GRID',
          completed: false,
          description: 'Choose up to 3',
          model: [],
          data: [],
          limit: 3,
        },
        {
          name: 'POTENSİYEL',
          type: 'GRID',
          completed: false,
          description: 'Choose up to 3',
          model: [],
          data: [],
          limit: 3,
        },
      ],
      research: {
        campaign_name: '',
        campaign_details: {
          age_min: 13,
          age_max: 65,
          genders: 0,
          life_stage: [],
        },
        campaign_questions: [],
        campaign_result: null,
      },
    };
  },
  computed: {
    activeStep() {
      return this.steps[this.step];
    },
    activeStepComponentName() {
      switch (this.activeStep.type) {
        case 'TREE': return 'SelectionTreeList';
        case 'GRID': return 'SelectionGridList';
        default: return '';
      }
    },
    lastStep() {
      return this.steps.length - 1;
    },
    notCompletedSteps() {
      return this.steps.filter((s) => !s.completed);
    },
    allStepsCompleted() {
      return this.notCompletedSteps.length === 0;
    },
    isSortableListVisible() {
      return this.activeStep.model.length !== 0;
    },
  },
  created() {
    this.getResearchStepData();

    if (this.$route.params.id) {
      this.getResearchDetails();
    } else {
      this.research.campaign_name = this.$ls.get('researchName');
    }
  },
  methods: {
    getCategories() {
      return API.get(API_CATEGORY);
    },
    getPotentials() {
      return API.get(API_POTENTIAL);
    },
    getOffers() {
      return API.get(API_OFFER);
    },
    getHooks() {
      return API.get(API_HOOK);
    },
    getMotivations() {
      return API.get(API_MOTIVATION);
    },
    getEndgames() {
      return API.get(API_ENDGAME);
    },
    getResearchStepData() {
      Promise.all([
        this.getOffers(),
        this.getEndgames(),
        this.getHooks(),
        this.getMotivations(),
        this.getPotentials(),
      ]).then((responses) => {
        responses.forEach((response, index) => {
          this.steps[index].data = responses[index].data;
        });

        this.showLoader = false;
      });

      // TODO will be removed
      this.getCategories().then((response) => {
        this.categories = response.data;
      });
    },
    getResearchDetails() {
      API.get(`${API_RESEARCH}/${this.$route.params.id}`)
        .then((response) => {
          this.research = response.data.data;
          const details = response.data.data.campaign_details;

          this.steps.forEach((step, index) => {
            this.steps[index].completed = true;
          });

          this.steps[0].model = [details.offer_id];
          this.steps[1].model = details.endgame_id;
          this.steps[2].model = details.hook_id;
          this.steps[3].model = details.motivation_id;
          this.steps[4].model = details.potential_id;

          this.showLoader = false;
        }).catch((err) => {
          this.$snotify.error(err.message);
          this.$router.push('/');
        });
    },
    displayStepWarnings() {
      this.notCompletedSteps.forEach((step, i) => {
        const self = this;

        setTimeout(() => {
          self.$snotify.warning(`Please select ${self.steps[i].name}`);
        }, i * 100);

        if (i === 0) this.step = this.steps.findIndex((s) => s.name === step.name);
      });
    },
    doResearch() {
      if (this.allStepsCompleted) {
        this.showLoader = true;

        const research = {
          campaign_name: this.research.campaign_name,
          campaign_details: {
            age_min: 13,
            age_max: 65,
            genders: 0,
            life_stage: [],
            category_id: this.selectedCategory,
            offer_id: this.steps[0].model[0]._id,
            endgame_id: this.steps[1].model.map((m) => m._id),
            hook_id: this.steps[2].model.map((m) => m._id),
            motivation_id: this.steps[3].model.map((m) => m._id),
            potential_id: this.steps[4].model.map((m) => m._id),
          },
        };

        const isResearchNew = !this.$route.params.id;

        const researchPromise = isResearchNew
          ? API.post(API_RESEARCH, research)
          : API.put(`${API_RESEARCH}/${this.$route.params.id}`, research);

        researchPromise.then((response) => {
          this.$router.push(`/research/${response.data.id}/clusters`);
        }).catch((err) => {
          this.showLoader = false;
          this.$snotify.error(err);
        });
      } else {
        this.displayStepWarnings();
      }
    },
  },
};
</script>
<style>
  #selection-sidebar .sidebar-sticky {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
</style>
